export default __webpack_public_path__ + "static/media/lucky-tnc-cn.174a4511.svg";